(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comunidad-instagram"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var activeSections = new WeakMap();

    function initSection(section) {
      if (activeSections.has(section)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var cards = [
        section.querySelector('.community-section__copy-card'),
        section.querySelector('.community-section__photo-card')
      ];
      if (!cards[0] || !cards[1]) return;
      var grid = section.querySelector('.community-section__grid');
      var mobileScreen = window.matchMedia('(max-width: 599px)');

      var shown = cards.map(readProgress);
      var rendered = [-1, -1];
      var mobileShown = 0;
      var mobileRendered = -1;
      var mode = null;
      var frame = null;
      var lastTime = 0;
      var visibleCards = new Set();

      function readProgress(card) {
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var mobile = window.matchMedia('(max-width: 1099px)').matches;
        var start = viewportHeight * 1.03;
        var end = viewportHeight * (mobile ? 0.50 : 0.37);
        var top = card.getBoundingClientRect().top;
        return Math.max(0, Math.min(1, (start - top) / (start - end)));
      }

      function readMobileProgress() {
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var top = grid.getBoundingClientRect().top;
        var stageHeight = parseFloat(window.getComputedStyle(grid).paddingTop) || 0;
        // La foto permanece grande una vez que ya está completamente visible.
        var start = viewportHeight * 0.45;
        var end = viewportHeight * 0.16 - stageHeight;
        return Math.max(0, Math.min(1, (start - top) / (start - end)));
      }

      function render(index, progress) {
        if (Math.abs(progress - rendered[index]) < 0.001) return;
        rendered[index] = progress;

        var distance = window.matchMedia('(max-width: 1099px)').matches ? 56 : 120;
        var direction = index === 0 ? -1 : 1;
        var offset = direction * (1 - progress) * distance;
        cards[index].style.opacity = progress.toFixed(3);
        cards[index].style.transform = 'translate3d(' + offset.toFixed(1) + 'px, 0, 0)';
        cards[index].style.willChange = progress > 0 && progress < 1 ? 'transform, opacity' : 'auto';
      }

      function renderMobile(progress) {
        if (Math.abs(progress - mobileRendered) < 0.001) return;
        mobileRendered = progress;

        var photo = cards[1];
        var availableWidth = grid.clientWidth - 14;
        var photoWidth = photo.offsetWidth || 128;
        var initialScale = Math.max(1, Math.min(3.2, availableWidth / photoWidth));
        var scale = 1 + (1 - progress) * (initialScale - 1);
        var stageHeight = parseFloat(window.getComputedStyle(grid).paddingTop) || 0;
        var cardOpacity = Math.max(0, Math.min(1, (progress - 0.18) / 0.72));

        cards[0].style.opacity = cardOpacity.toFixed(3);
        cards[0].style.transform = 'translate3d(0, ' + ((1 - progress) * 56).toFixed(1) + 'px, 0)';
        cards[0].style.willChange = progress > 0 && progress < 1 ? 'transform, opacity' : 'auto';
        photo.style.opacity = '1';
        photo.style.transform = 'translate3d(0, ' + (-(1 - progress) * stageHeight).toFixed(1) + 'px, 0) scale(' + scale.toFixed(4) + ')';
        photo.style.willChange = progress > 0 && progress < 1 ? 'transform' : 'auto';
      }

      function syncMode() {
        var nextMode = mobileScreen.matches ? 'mobile' : 'desktop';
        if (nextMode === mode) return;
        mode = nextMode;
        section.classList.toggle('community-section--mobile-animated', mode === 'mobile');
        cards.forEach(function (card) {
          card.style.opacity = '';
          card.style.transform = '';
          card.style.willChange = 'auto';
        });
        if (mode === 'mobile') {
          mobileShown = readMobileProgress();
          mobileRendered = -1;
          renderMobile(mobileShown);
        } else {
          shown = cards.map(readProgress);
          rendered = [-1, -1];
          cards.forEach(function (card, index) { render(index, shown[index]); });
        }
      }

      function update(time) {
        frame = null;
        syncMode();
        var elapsed = lastTime ? Math.min(time - lastTime, 64) : 16;
        lastTime = time;
        var moving = false;

        if (mode === 'mobile') {
          var mobileTarget = readMobileProgress();
          var mobileDifference = mobileTarget - mobileShown;
          mobileShown = Math.abs(mobileDifference) < 0.003
            ? mobileTarget
            : mobileShown + mobileDifference * (1 - Math.exp(-elapsed / 120));
          renderMobile(mobileShown);
          moving = Math.abs(mobileTarget - mobileShown) >= 0.003;
        } else {
          cards.forEach(function (card, index) {
            var target = readProgress(card);
            var difference = target - shown[index];

            // Suaviza los saltos de la rueda sin desligar el movimiento del scroll.
            shown[index] = Math.abs(difference) < 0.003
              ? target
              : shown[index] + difference * (1 - Math.exp(-elapsed / 120));
            render(index, shown[index]);
            if (Math.abs(target - shown[index]) >= 0.003) moving = true;
          });
        }

        if (visibleCards.size || moving) requestUpdate();
      }

      function requestUpdate() {
        if (frame === null) frame = window.requestAnimationFrame(update);
      }

      syncMode();

      // Sigue las tarjetas incluso si el tema anima el desplazamiento con transforms.
      var observer = 'IntersectionObserver' in window
        ? new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) visibleCards.add(entry.target);
              else visibleCards.delete(entry.target);
            });
            requestUpdate();
          }, { rootMargin: '60% 0px 60% 0px' })
        : null;
      if (observer) cards.forEach(function (card) { observer.observe(card); });

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      window.addEventListener('pageshow', requestUpdate);

      activeSections.set(section, function () {
        window.removeEventListener('scroll', requestUpdate);
        window.removeEventListener('resize', requestUpdate);
        window.removeEventListener('pageshow', requestUpdate);
        if (observer) observer.disconnect();
        if (frame !== null) window.cancelAnimationFrame(frame);
      });
    }

    function eachSection(root, callback) {
      if (root.matches && root.matches('[data-community-scroll]')) callback(root);
      if (root.querySelectorAll) root.querySelectorAll('[data-community-scroll]').forEach(callback);
    }

    document.addEventListener('shopify:section:load', function (event) {
      eachSection(event.target, initSection);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      eachSection(event.target, function (section) {
        var cleanup = activeSections.get(section);
        if (cleanup) cleanup();
        activeSections.delete(section);
      });
    });

    function initAll() { eachSection(document, initSection); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frase-cafe-scroll"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__cdlPhraseInitialized) return;
    window.__cdlPhraseInitialized = true;

    const active = new Map();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const clamp = (value) => Math.max(0, Math.min(1, value));

    function init(root) {
      if (active.has(root)) return;
      const heading = root.querySelector('[data-cdl-phrase-heading]');
      if (!heading) return;
      const phrase = heading.textContent.trim().replace(/\s+/g, ' ');
      if (!phrase) return;

      const fragment = document.createDocumentFragment();
      const words = phrase.split(' ').map((text, index) => {
        if (index) fragment.appendChild(document.createTextNode(' '));
        const word = document.createElement('span');
        word.className = 'cdl-phrase__word';
        word.textContent = text;
        word.dataset.word = text;
        word.setAttribute('aria-hidden', 'true');
        fragment.appendChild(word);
        return word;
      });
      heading.setAttribute('aria-label', phrase);
      heading.replaceChildren(fragment);

      let frame = null;
      let shown = 0;
      let lastTime = 0;
      let tracking = false;

      function progress() {
        const viewport = window.innerHeight || document.documentElement.clientHeight;
        return clamp((viewport - root.getBoundingClientRect().top) / viewport);
      }

      function render(value) {
        // La frase entra junto con la sección y se acomoda en el centro.
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        root.style.setProperty('--phrase-position', ((1 - value) * (mobile ? -42 : -48)).toFixed(2) + 'vh');
        // Todas las palabras quedan legibles en la primera parte del recorrido.
        const revealProgress = clamp(value / .58);
        words.forEach((word, index) => {
          const start = index / words.length * .78;
          const reveal = clamp((revealProgress - start) / .22);
          const eased = 1 - Math.pow(1 - reveal, 3);
          word.style.opacity = eased.toFixed(3);
          word.style.transform = 'translate3d(' + ((1 - eased) * -.6).toFixed(3) + 'em,0,0) scaleX(' + (1 + (1 - eased) * .35).toFixed(3) + ')';
          word.style.filter = 'blur(' + ((1 - eased) * 14).toFixed(1) + 'px)';
          word.style.setProperty('--phrase-ghost-opacity', (Math.sin(reveal * Math.PI) * .33).toFixed(3));
          word.style.setProperty('--phrase-ghost-x', ((1 - reveal) * -30).toFixed(1) + 'px');
          word.style.willChange = reveal > 0 && reveal < 1 ? 'transform, opacity, filter' : 'auto';
        });
      }

      function update(time) {
        frame = null;
        if (!root.isConnected || reducedMotion.matches) return;
        const target = progress();
        const elapsed = lastTime ? Math.min(time - lastTime, 64) : 16;
        lastTime = time;
        shown = Math.abs(target - shown) < .002
          ? target
          : shown + (target - shown) * (1 - Math.exp(-elapsed / 90));
        render(shown);
        // Algunos temas de escritorio desplazan un contenedor con transform.
        // En ese caso cambia getBoundingClientRect() sin dispararse window.scroll.
        if (tracking || Math.abs(target - shown) >= .002) requestUpdate();
      }

      function requestUpdate() {
        if (frame === null && !reducedMotion.matches) frame = requestAnimationFrame(update);
      }

      function motionChanged() {
        if (reducedMotion.matches) {
          if (frame !== null) cancelAnimationFrame(frame);
          frame = null;
          root.classList.remove('cdl-phrase--ready');
        } else {
          shown = progress();
          render(shown);
          root.classList.add('cdl-phrase--ready');
          requestUpdate();
        }
      }

      if (!reducedMotion.matches) {
        shown = progress();
        render(shown);
        root.classList.add('cdl-phrase--ready');
      }
      const observer = 'IntersectionObserver' in window
        ? new IntersectionObserver((entries) => {
            tracking = entries[0].isIntersecting;
            requestUpdate();
          }, { rootMargin: '45% 0px 45% 0px' })
        : null;
      if (observer) observer.observe(root);
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      window.addEventListener('pageshow', requestUpdate);
      reducedMotion.addEventListener('change', motionChanged);
      active.set(root, () => {
        window.removeEventListener('scroll', requestUpdate);
        window.removeEventListener('resize', requestUpdate);
        window.removeEventListener('pageshow', requestUpdate);
        reducedMotion.removeEventListener('change', motionChanged);
        if (observer) observer.disconnect();
        if (frame !== null) cancelAnimationFrame(frame);
      });
    }

    function forEachSection(container, callback) {
      if (container.matches && container.matches('[data-cdl-phrase]')) callback(container);
      if (container.querySelectorAll) container.querySelectorAll('[data-cdl-phrase]').forEach(callback);
    }

    function initAll(container) { forEachSection(container, init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
    else initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      forEachSection(event.target, (root) => {
        const cleanup = active.get(root);
        if (cleanup) cleanup();
        active.delete(root);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tarjetas-informativas"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__cdlStoriesInitialized) return;
    window.__cdlStoriesInitialized = true;
    const active = new WeakMap();

    function init(root) {
      if (active.has(root)) return;
      const carousel = root.querySelector('.cdl-stories__carousel');
      const viewport = root.querySelector('.cdl-stories__viewport');
      const track = root.querySelector('.cdl-stories__track');
      const revealAnchor = root.querySelector('.cdl-stories__reveal-anchor');
      if (!carousel || !viewport || !track) return;
      const slides = Array.from(track.querySelectorAll('[data-story-slide]'));
      if (!slides.length) return;
      const autoplayToggle = root.querySelector('[data-story-autoplay-toggle]');
      const announcement = root.querySelector('.cdl-stories__announcement');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const interval = Math.max(6, Number(root.dataset.interval) || 9) * 1000;
      const autoplayEnabled = root.dataset.autoplay === 'true' && root.dataset.designMode !== 'true' && slides.length > 1;
      let index = 0;
      let position = 1;
      let locked = false;
      let wrapTo = null;
      let timer = null;
      let transitionTimer = null;
      let visible = !('IntersectionObserver' in window);
      let hovering = false;
      let focusing = false;
      let pausedByUser = false;
      let dragging = null;
      let revealShown = 1;
      let revealRendered = -1;
      let revealFrame = null;
      let revealLastTime = 0;
      let revealNearby = false;
      let revealPlaybackReady = !revealAnchor;
      const listeners = [];

      function listen(target, name, handler, options) {
        target.addEventListener(name, handler, options);
        listeners.push(() => target.removeEventListener(name, handler, options));
      }

      function makeClone(source) {
        const clone = source.cloneNode(true);
        clone.removeAttribute('data-story-slide');
        clone.removeAttribute('data-block-id');
        clone.setAttribute('aria-hidden', 'true');
        clone.inert = true;
        [clone, ...clone.querySelectorAll('*')].forEach((element) => {
          Array.from(element.attributes).forEach((attribute) => {
            if (attribute.name.startsWith('data-shopify-') || attribute.name === 'id') element.removeAttribute(attribute.name);
          });
        });
        return clone;
      }

      track.insertBefore(makeClone(slides[slides.length - 1]), slides[0]);
      track.appendChild(makeClone(slides[0]));
      track.style.transform = 'translate3d(-100%, 0, 0)';

      function updateActive(announce) {
        slides.forEach((slide, slideIndex) => {
          const selected = slideIndex === index;
          slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
          slide.inert = !selected;
        });
        if (announce && announcement) announcement.textContent = 'Tarjeta ' + (index + 1) + ' de ' + slides.length + ': ' + (slides[index].querySelector('.cdl-stories__slide-heading')?.textContent || '');
      }

      function readRevealProgress() {
        if (!revealAnchor) return 1;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const start = viewportHeight * 0.95;
        const end = viewportHeight * 0.18;
        const top = revealAnchor.getBoundingClientRect().top;
        return Math.max(0, Math.min(1, (start - top) / (start - end)));
      }

      function renderReveal(progress) {
        carousel.style.willChange = progress > 0.01 && progress < 0.99 ? 'transform, clip-path, opacity' : 'auto';
        if (Math.abs(progress - revealRendered) < 0.001) return;
        revealRendered = progress;
        const eased = progress * progress * (3 - 2 * progress);
        const remaining = 1 - eased;
        root.style.setProperty('--stories-reveal-inset-y', (remaining * 29).toFixed(2) + '%');
        root.style.setProperty('--stories-reveal-inset-x', (remaining * 7).toFixed(2) + '%');
        root.style.setProperty('--stories-reveal-scale', (0.94 + eased * 0.06).toFixed(4));
        root.style.setProperty('--stories-reveal-y', (remaining * 58).toFixed(1) + 'px');
        root.style.setProperty('--stories-reveal-opacity', (0.46 + eased * 0.54).toFixed(3));
        root.classList.add('cdl-stories--scroll-ready');
      }

      function requestReveal() {
        if (revealFrame === null) revealFrame = window.requestAnimationFrame(updateReveal);
      }

      function updateReveal(time) {
        revealFrame = null;
        if (!root.isConnected) return;
        if (reducedMotion.matches) {
          root.classList.remove('cdl-stories--scroll-ready');
          carousel.style.willChange = 'auto';
          revealShown = 1;
        } else {
          const target = readRevealProgress();
          const elapsed = revealLastTime ? Math.min(time - revealLastTime, 64) : 16;
          revealLastTime = time;
          const difference = target - revealShown;
          revealShown = Math.abs(difference) < 0.003
            ? target : revealShown + difference * (1 - Math.exp(-elapsed / 110));
          renderReveal(revealShown);
          if (revealNearby || Math.abs(target - revealShown) >= 0.003) requestReveal();
        }
        const ready = revealShown >= 0.98;
        if (ready !== revealPlaybackReady) { revealPlaybackReady = ready; schedule(); }
      }

      function pause() { if (timer) window.clearTimeout(timer); timer = null; }
      function canAutoplay() { return autoplayEnabled && revealPlaybackReady && !pausedByUser && visible && !hovering && !focusing && !dragging && !document.hidden && !reducedMotion.matches; }
      function schedule() {
        pause();
        if (canAutoplay()) timer = window.setTimeout(() => move(index + 1, false), interval);
      }

      function finish() {
        if (!locked) return;
        window.clearTimeout(transitionTimer);
        transitionTimer = null;
        if (wrapTo !== null) {
          root.classList.remove('cdl-stories--ready');
          position = wrapTo;
          track.style.transform = 'translate3d(-' + (position * 100) + '%, 0, 0)';
          void track.offsetWidth;
          root.classList.add('cdl-stories--ready');
          wrapTo = null;
        }
        locked = false;
        schedule();
      }

      function move(target, announce) {
        if (locked || slides.length < 2) return;
        if (target === index) { schedule(); return; }
        pause();
        if (target >= slides.length && index === slides.length - 1) {
          index = 0;
          position = slides.length + 1;
          wrapTo = 1;
        } else if (target < 0 && index === 0) {
          index = slides.length - 1;
          position = 0;
          wrapTo = slides.length;
        } else {
          index = ((target % slides.length) + slides.length) % slides.length;
          position = index + 1;
          wrapTo = null;
        }
        updateActive(announce);
        track.style.transform = 'translate3d(-' + (position * 100) + '%, 0, 0)';
        if (reducedMotion.matches) {
          locked = true;
          finish();
        } else {
          locked = true;
          transitionTimer = window.setTimeout(finish, 850);
        }
      }

      updateActive(false);
      if (revealAnchor && !reducedMotion.matches) {
        revealShown = readRevealProgress();
        revealPlaybackReady = revealShown >= 0.98;
        renderReveal(revealShown);
      }
      window.requestAnimationFrame(() => {
        if (!root.isConnected) return;
        root.classList.add('cdl-stories--ready');
        schedule();
      });

      listen(track, 'transitionend', (event) => { if (event.target === track && event.propertyName === 'transform') finish(); });
      listen(root.querySelector('[data-story-previous]'), 'click', () => move(index - 1, true));
      listen(root.querySelector('[data-story-next]'), 'click', () => move(index + 1, true));
      if (autoplayToggle) listen(autoplayToggle, 'click', () => {
        pausedByUser = !pausedByUser;
        autoplayToggle.setAttribute('aria-pressed', pausedByUser ? 'true' : 'false');
        autoplayToggle.setAttribute('aria-label', pausedByUser ? 'Reanudar cambio automático' : 'Pausar cambio automático');
        schedule();
      });
      listen(viewport, 'keydown', (event) => {
        if (event.key === 'ArrowRight') { event.preventDefault(); move(index + 1, true); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); move(index - 1, true); }
      });
      listen(viewport, 'pointerdown', (event) => {
        if (event.target.closest('button, a')) return;
        dragging = { x: event.clientX, y: event.clientY, id: event.pointerId };
        pause();
      });
      listen(window, 'pointerup', (event) => {
        if (!dragging || event.pointerId !== dragging.id) return;
        const dx = event.clientX - dragging.x;
        const dy = event.clientY - dragging.y;
        dragging = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) move(index + (dx < 0 ? 1 : -1), true);
        else schedule();
      });
      listen(window, 'pointercancel', () => { dragging = null; schedule(); });
      listen(root, 'mouseenter', () => { hovering = true; pause(); });
      listen(root, 'mouseleave', () => { hovering = false; schedule(); });
      listen(root, 'focusin', () => { focusing = true; pause(); });
      listen(root, 'focusout', (event) => { if (!root.contains(event.relatedTarget)) { focusing = false; schedule(); } });
      listen(document, 'visibilitychange', schedule);
      if (reducedMotion.addEventListener) listen(reducedMotion, 'change', () => { requestReveal(); schedule(); });
      listen(window, 'scroll', requestReveal, { passive: true });
      listen(window, 'resize', requestReveal);
      listen(window, 'pageshow', requestReveal);

      const revealObserver = revealAnchor && 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
        revealNearby = entries.some((entry) => entry.isIntersecting);
        requestReveal();
      }, { rootMargin: '60% 0px 60% 0px' }) : null;
      if (revealObserver) revealObserver.observe(root);

      const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
        visible = entries.some((entry) => entry.isIntersecting);
        if (visible) slides.forEach((slide) => {
          const image = slide.querySelector('.cdl-stories__image');
          if (image) image.loading = 'eager';
        });
        schedule();
      }, { threshold: 0.3 }) : null;
      if (observer) observer.observe(root);

      active.set(root, {
        select: (slideIndex) => {
          if (locked) finish();
          move(slideIndex, false);
        },
        cleanup: () => {
          pause();
          window.clearTimeout(transitionTimer);
          if (observer) observer.disconnect();
          if (revealObserver) revealObserver.disconnect();
          if (revealFrame !== null) window.cancelAnimationFrame(revealFrame);
          listeners.forEach((remove) => remove());
        }
      });
    }

    function each(root, callback) {
      if (root.matches && root.matches('[data-cdl-stories]')) callback(root);
      if (root.querySelectorAll) root.querySelectorAll('[data-cdl-stories]').forEach(callback);
    }

    document.addEventListener('shopify:section:load', (event) => each(event.target, init));
    document.addEventListener('shopify:section:unload', (event) => each(event.target, (root) => {
      const instance = active.get(root);
      if (instance) instance.cleanup();
      active.delete(root);
    }));
    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest && event.target.closest('[data-story-slide]');
      if (!slide) return;
      const root = slide.closest('[data-cdl-stories]');
      if (!root) return;
      const instance = active.get(root);
      if (instance) instance.select(Array.from(root.querySelectorAll('[data-story-slide]')).indexOf(slide));
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => each(document, init), { once: true });
    else each(document, init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["titulo-scroll-tienda"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var activeSections = new WeakMap();

    function initSection(section) {
      if (activeSections.has(section)) return;

      var heading = section.querySelector('[data-scroll-title-heading]');
      if (!heading) return;

      var text = heading.textContent.trim();
      if (!text) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        activeSections.set(section, function () {});
        return;
      }

      var fragment = document.createDocumentFragment();
      var letters = [];
      var words = text.split(/\s+/);
      var segmenter = typeof Intl.Segmenter === 'function'
        ? new Intl.Segmenter(document.documentElement.lang || 'es', { granularity: 'grapheme' })
        : null;

      words.forEach(function (word, wordIndex) {
        if (wordIndex > 0) fragment.appendChild(document.createTextNode(' '));

        var wordElement = document.createElement('span');
        wordElement.className = 'scroll-title-section__word';
        wordElement.setAttribute('aria-hidden', 'true');

        var characters = segmenter
          ? Array.from(segmenter.segment(word), function (item) { return item.segment; })
          : Array.from(word);

        characters.forEach(function (character) {
          var letter = document.createElement('span');
          letter.className = 'scroll-title-section__letter';
          letter.textContent = character;
          wordElement.appendChild(letter);
          letters.push(letter);
        });

        fragment.appendChild(wordElement);
      });

      heading.setAttribute('aria-label', text);
      heading.replaceChildren(fragment);
      section.classList.add('is-animated');

      var frame = null;
      var tracking = false;
      var lastTime = 0;
      var shownProgress = readProgress();
      var renderedProgress = -1;

      function readProgress() {
        // En escritorio hay más recorrido para que la rueda no salte toda la animación.
        var top = heading.getBoundingClientRect().top;
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var mobile = window.matchMedia('(max-width: 749px)').matches;
        var start = viewportHeight * (mobile ? 0.94 : 1.06);
        var end = viewportHeight * (mobile ? 0.62 : 0.50);
        return Math.max(0, Math.min(1, (start - top) / (start - end)));
      }

      function render(progress) {
        if (Math.abs(progress - renderedProgress) < 0.001) return;
        renderedProgress = progress;
        var count = letters.length;

        letters.forEach(function (letter, index) {
          var reveal = Math.max(0, Math.min(1, (progress - index / count * 0.72) / 0.28));
          letter.style.opacity = reveal.toFixed(3);
          letter.style.transform = 'translate3d(0, ' + ((1 - reveal) * 0.55).toFixed(3) + 'em, 0) rotate(' + ((1 - reveal) * -6).toFixed(2) + 'deg)';
          letter.style.willChange = reveal >= 1 ? 'auto' : 'opacity, transform';
        });
      }

      function update(time) {
        frame = null;

        var target = readProgress();
        var difference = target - shownProgress;
        var elapsed = lastTime ? Math.min(time - lastTime, 64) : 16;
        lastTime = time;

        // Completa los saltos grandes del scroll con una transición visible.
        shownProgress = Math.abs(difference) < 0.003
          ? target
          : shownProgress + difference * (1 - Math.exp(-elapsed / 110));
        render(shownProgress);

        if (tracking || Math.abs(target - shownProgress) >= 0.003) requestUpdate();
      }

      function requestUpdate() {
        if (frame === null) frame = window.requestAnimationFrame(update);
      }

      render(shownProgress);

      // Detecta también temas que desplazan la página mediante transformaciones.
      var observer = 'IntersectionObserver' in window
        ? new IntersectionObserver(function (entries) {
            tracking = entries[0].isIntersecting;
            requestUpdate();
          }, { rootMargin: '70% 0px 70% 0px' })
        : null;
      if (observer) observer.observe(heading);

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      window.addEventListener('pageshow', requestUpdate);

      activeSections.set(section, function () {
        window.removeEventListener('scroll', requestUpdate);
        window.removeEventListener('resize', requestUpdate);
        window.removeEventListener('pageshow', requestUpdate);
        if (observer) observer.disconnect();
        if (frame !== null) window.cancelAnimationFrame(frame);
      });
    }

    function eachSection(root, callback) {
      if (root.matches && root.matches('[data-scroll-title-section]')) callback(root);
      if (root.querySelectorAll) {
        root.querySelectorAll('[data-scroll-title-section]').forEach(callback);
      }
    }

    function initAll() {
      eachSection(document, initSection);
    }

    document.addEventListener('shopify:section:load', function (event) {
      eachSection(event.target, initSection);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      eachSection(event.target, function (section) {
        var cleanup = activeSections.get(section);
        if (cleanup) cleanup();
        activeSections.delete(section);
      });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ubicacion-mapa-monocromatico"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__cdlLocationInitialized) return;
    window.__cdlLocationInitialized = true;

    const sections = new Set();
    const animations = new WeakMap();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let googleMapsPromise;
    let mapAuthFailed = false;
    const previousAuthFailure = window.gm_authFailure;
    window.gm_authFailure = function () {
      mapAuthFailed = true;
      document.querySelectorAll('[data-cdl-location]').forEach((root) => root.classList.remove('cdl-location--map-ready'));
      if (typeof previousAuthFailure === 'function') previousAuthFailure();
    };

    const mapObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        mapObserver.unobserve(entry.target);
        const root = entry.target;
        loadGoogleMaps(root.dataset.mapKey.trim()).then((maps) => createMap(root, maps)).catch(() => {
          /* El iframe visible conserva un mapa interactivo si la API falla. */
        });
      });
    }, { rootMargin: '500px 0px' }) : null;

    function loadGoogleMaps(key) {
      if (window.google && window.google.maps && window.google.maps.Map) return Promise.resolve(window.google.maps);
      if (googleMapsPromise) return googleMapsPromise;

      googleMapsPromise = new Promise((resolve, reject) => {
        const callback = '__cdlLocationMapReady';
        const timeout = window.setTimeout(() => {
          delete window[callback];
          reject(new Error('Google Maps no respondió a tiempo'));
        }, 20000);
        window[callback] = () => {
          window.clearTimeout(timeout);
          delete window[callback];
          resolve(window.google.maps);
        };
        const script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&loading=async&callback=' + callback;
        script.async = true;
        script.onerror = () => {
          window.clearTimeout(timeout);
          delete window[callback];
          reject(new Error('No se pudo cargar Google Maps'));
        };
        document.head.appendChild(script);
      });
      return googleMapsPromise;
    }

    function createMap(root, maps) {
      if (!root.isConnected || mapAuthFailed || root.classList.contains('cdl-location--map-ready')) return;
      const latitude = Number.parseFloat(root.dataset.latitude);
      const longitude = Number.parseFloat(root.dataset.longitude);
      if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return;
      const center = { lat: latitude, lng: longitude };
      const map = new maps.Map(root.querySelector('.cdl-location__styled-map'), {
        center,
        zoom: Number.parseInt(root.dataset.zoom, 10) || 16,
        gestureHandling: 'cooperative',
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true,
        zoomControl: true,
        clickableIcons: false,
        styles: [
          { featureType: 'all', elementType: 'geometry', stylers: [{ saturation: -100 }] },
          { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#e8e8e6' }] },
          { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#dededb' }] },
          { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
          { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#d2d2cf' }] },
          { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#cacac8' }] },
          { featureType: 'transit', elementType: 'geometry', stylers: [{ color: '#d7d7d4' }] },
          { featureType: 'all', elementType: 'labels.text.fill', stylers: [{ color: '#555552' }] },
          { featureType: 'all', elementType: 'labels.text.stroke', stylers: [{ color: '#f7f7f5' }] },
          { featureType: 'poi.business', elementType: 'labels', stylers: [{ visibility: 'off' }] }
        ]
      });

      class CafePin extends maps.OverlayView {
        constructor() { super(); this.element = null; this.setMap(map); }
        onAdd() {
          const pin = document.createElement('a');
          pin.className = 'cdl-location__pin';
          pin.href = root.dataset.mapsUrl;
          pin.target = '_blank';
          pin.rel = 'noopener noreferrer';
          pin.setAttribute('aria-label', 'Abrir Café de Ley en Google Maps');
          pin.innerHTML = '<span class="cdl-location__pin-dot" aria-hidden="true"></span><span>CAFÉ DE LEY</span>';
          this.element = pin;
          this.getPanes().overlayMouseTarget.appendChild(pin);
        }
        draw() {
          if (!this.element) return;
          const position = this.getProjection().fromLatLngToDivPixel(new maps.LatLng(latitude, longitude));
          if (position) { this.element.style.left = position.x + 'px'; this.element.style.top = position.y + 'px'; }
        }
        onRemove() { if (this.element) this.element.remove(); this.element = null; }
      }
      new CafePin();
      root.classList.add('cdl-location--map-ready');
    }

    function setupAnimation(root) {
      const cards = [root.querySelector('[data-cdl-reveal="map"]'), root.querySelector('[data-cdl-reveal="card"]')];
      if (!cards[0] || !cards[1]) return;

      const shown = [0, 0];
      const rendered = [-1, -1];
      const visibleCards = new Set();
      let frame = null;
      let lastTime = 0;

      function mobile() { return window.matchMedia('(max-width: 900px)').matches; }
      function distanceY() { return mobile() ? 54 : 100; }

      function readProgress(card, index) {
        const viewport = window.innerHeight || document.documentElement.clientHeight;
        const start = viewport * 1.03;
        const end = viewport * (mobile() ? 0.48 : 0.36);
        // getBoundingClientRect incluye el movimiento vertical aplicado por esta animación.
        // Se resta para medir la posición real de la tarjeta en el documento.
        const appliedY = root.classList.contains('cdl-location--animated') && rendered[index] >= 0
          ? (1 - rendered[index]) * distanceY() : 0;
        const top = card.getBoundingClientRect().top - appliedY;
        return Math.max(0, Math.min(1, (start - top) / (start - end)));
      }

      function render(index, progress) {
        if (Math.abs(progress - rendered[index]) < 0.001) return;
        rendered[index] = progress;
        const direction = index === 0 ? -1 : 1;
        const distanceX = mobile() ? 58 : 130;
        cards[index].style.setProperty('--cdl-x', (direction * (1 - progress) * distanceX).toFixed(1) + 'px');
        cards[index].style.setProperty('--cdl-y', ((1 - progress) * distanceY()).toFixed(1) + 'px');
        cards[index].style.setProperty('--cdl-opacity', progress.toFixed(3));
        cards[index].style.willChange = progress > 0 && progress < 1 ? 'transform, opacity' : 'auto';
        root.classList.add('cdl-location--animated');
      }

      function update(time) {
        frame = null;
        if (!root.isConnected || reducedMotion.matches) {
          root.classList.remove('cdl-location--animated');
          rendered[0] = rendered[1] = -1;
          return;
        }

        const elapsed = lastTime ? Math.min(time - lastTime, 64) : 16;
        lastTime = time;
        let moving = false;
        cards.forEach((card, index) => {
          const target = readProgress(card, index);
          const difference = target - shown[index];
          // La suavidad funciona en los dos sentidos del scroll.
          shown[index] = Math.abs(difference) < 0.003
            ? target : shown[index] + difference * (1 - Math.exp(-elapsed / 120));
          render(index, shown[index]);
          if (Math.abs(target - shown[index]) >= 0.003) moving = true;
        });
        if (visibleCards.size || moving) requestUpdate();
      }

      function requestUpdate() {
        if (frame === null) frame = window.requestAnimationFrame(update);
      }

      cards.forEach((card, index) => {
        shown[index] = readProgress(card, index);
        if (!reducedMotion.matches) render(index, shown[index]);
      });

      // El tema puede desplazar la página mediante transforms sin disparar eventos scroll.
      const observer = 'IntersectionObserver' in window
        ? new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) visibleCards.add(entry.target);
              else visibleCards.delete(entry.target);
            });
            requestUpdate();
          }, { rootMargin: '60% 0px 60% 0px' })
        : null;
      if (observer) cards.forEach((card) => observer.observe(card));

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      window.addEventListener('pageshow', requestUpdate);
      if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', requestUpdate);
      animations.set(root, () => {
        window.removeEventListener('scroll', requestUpdate);
        window.removeEventListener('resize', requestUpdate);
        window.removeEventListener('pageshow', requestUpdate);
        if (reducedMotion.removeEventListener) reducedMotion.removeEventListener('change', requestUpdate);
        if (observer) observer.disconnect();
        if (frame !== null) window.cancelAnimationFrame(frame);
      });
    }

    function init(root) {
      if (!root || sections.has(root)) return;
      sections.add(root);
      setupAnimation(root);
      const key = (root.dataset.mapKey || '').trim();
      if (key && mapObserver) mapObserver.observe(root);
      else if (key) loadGoogleMaps(key).then((maps) => createMap(root, maps)).catch(() => {
        /* El iframe visible conserva un mapa interactivo si la API falla. */
      });
    }

    function initAll(container) {
      if (container.matches && container.matches('[data-cdl-location]')) init(container);
      container.querySelectorAll('[data-cdl-location]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
    else initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const remove = (root) => {
        const cleanup = animations.get(root);
        if (cleanup) cleanup();
        animations.delete(root);
        sections.delete(root);
        if (mapObserver) mapObserver.unobserve(root);
      };
      if (event.target.matches && event.target.matches('[data-cdl-location]')) remove(event.target);
      event.target.querySelectorAll('[data-cdl-location]').forEach(remove);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
